import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverlayComponent } from './components/overlay/overlay.component';
import { LoaderComponent } from './components/loader/loader.component';
import { Loader2Component } from './components/loader2/loader2.component';
import { TableComponent } from './components/table/table.component';
import { BlockLettersDirective } from './utils/directives/block-letters.directive';
import { OnlyNumbersDirective } from './utils/directives/only-numbers.directive';
import { SortPipe } from './utils/pipes/sort.pipe';
import { AgoPipe } from './utils/pipes/ago.pipe';
import { ArrowBackComponent } from './components/arrow-back/arrow-back.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { PedimentoComponent } from './pages/pedimento/pedimento.component';
import { StatusComponent } from './components/status/status.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MembratedLetterComponent } from './components/membrated-letter/membrated-letter.component';
import { TonsPerYardComponent } from './components/tons-per-yard/tons-per-yard.component';
import { AmountsByInputLocationsComponent } from './components/amounts-by-input-locations/amounts-by-input-locations.component';
import { OutputFormToAnotherPatioComponent } from './components/output-form-to-another-patio/output-form-to-another-patio.component';
import { PreSamplingRecordComponent } from './components/pre-sampling-record/pre-sampling-record.component';
import { NotificationDropdownComponent } from './components/notification-dropdown/notification-dropdown.component';
import { NgSelectModule } from '@ng-select/ng-select';

/**
 * Módulo compartido que agrupa y exporta los componentes, directivas y pipes
 * reutilizables (overlays, loaders, tablas, estados, pedimento, cartas
 * membretadas, etc.) para que el resto de módulos de la aplicación los consuman.
 */
@NgModule({
  declarations: [
    OverlayComponent,
    LoaderComponent,
    Loader2Component,
    TableComponent,
    ArrowBackComponent,
    EmptyStateComponent,
    StatusComponent,
    PedimentoComponent,
    MembratedLetterComponent,
    TonsPerYardComponent,
    AmountsByInputLocationsComponent,
    OutputFormToAnotherPatioComponent,
    PreSamplingRecordComponent,
    NotificationDropdownComponent,

    BlockLettersDirective,
    OnlyNumbersDirective,

    SortPipe,
    AgoPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
  ],
  exports: [
    OverlayComponent,
    LoaderComponent,
    Loader2Component,
    TableComponent,
    EmptyStateComponent,
    ArrowBackComponent,
    PedimentoComponent,
    MembratedLetterComponent,
    TonsPerYardComponent,
    AmountsByInputLocationsComponent,
    OutputFormToAnotherPatioComponent,
    PreSamplingRecordComponent,
    NotificationDropdownComponent,

    BlockLettersDirective,
    OnlyNumbersDirective,

    SortPipe,
    AgoPipe,

    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
  ]
})
export class SharedModule { }
